<template>
    <div ref="chatComponentDom">
        <iframe ref="chatIframeDom" class="chat-iframe" :src="chatRoomUrl" seamless="seamless" :style="{width: chatWidth, height: chatHeight}"></iframe>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, toRef, onUnmounted} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import {useChatinfo} from "@/stores/chatinfo";
    import chatApi from "@/request/chatApi";

    const props = defineProps(['width', 'height'])

    const { proxy } = getCurrentInstance();

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    const chatInfoRef = toRef(useChatinfo())

    const refWidth = ref(425)

    const chatWidth = ref('425px')
    const chatHeight = ref('425px')

    const chatRoomUrl = ref(null)

    //聊天iframe是否已就緒
    let chatIframeReadyFlag = false
    //聊天iframe就緒後要執行的方法
    let chatReadyFunc = null

    function handleChatMsgEvent(e){
        chatIframeReadyFlag = true

        if (e.data.type === "unreadMsgCount"){
            chatInfoRef.value.msgCount = e.data.data
        }

        if (null != chatReadyFunc && typeof chatReadyFunc === "function"){
            const func = chatReadyFunc
            chatReadyFunc = null
            func()
        }
    }

    async function goMaterialChat(login, url){
        const request = chatApi.openPersonalRoom
        const params = request.getParams()

        params.token = userInfoRef.value.token
        params.users[0].account = login

        request.send(params, (res) => {
            proxy.$refs.chatIframeDom.contentWindow.postMessage({ type: 'goUserRoomAndMessage',  data: {roomId: res.data, message: url} }, '*')
        })

    }

    async function openPersonChat(login, flag) {
        if (!chatIframeReadyFlag){
            chatReadyFunc = () => {
                openPersonChat(login, flag)
            }
        }

        const request = chatApi.openPersonalRoom
        const params = request.getParams()

        params.token = userInfoRef.value.token
        params.users[0].account = login

        request.send(params, (res) => {
            const datas = {
                roomid: res.data,
            }

            if (flag){
                datas.goMaterialFlag = true
            }

            proxy.$refs.chatIframeDom.contentWindow.postMessage({ type: 'goUserRoom',  data: datas }, '*')
        })

    }

    onMounted(() => {
        if (null != props.width && null != props.height){
            chatWidth.value = props.width
            chatHeight.value = props.height
        }

        window.addEventListener("message", handleChatMsgEvent)
        refWidth.value = proxy.$refs.chatComponentDom.offsetWidth
        // chatWidth.value = refWidth.value

        chatRoomUrl.value = `${proxy.$ShopopeeUrl}/enterChatRoom?login=${userInfoRef.value.login}&password=${userInfoRef.value.password}&tag=3dshopopee&rrr=${proxy.$versionNum}`
        // chatRoomUrl.value = `${proxy.$ShopopeeUrl}/liveChat?tag=3dshopopee`

    })

    onUnmounted(() => {
        window.removeEventListener("message", handleChatMsgEvent)
    })

    defineExpose({
        openPersonChat,
        goMaterialChat
    })
</script>

<style scoped>
    .chat-iframe {
        border: 0;
    }
</style>